<template>
    <!-- modal-xl -->
    <b-modal id="certificateSharingModal" size="xl" title="Certificate Sharing Modal" title-class="font-18" hide-footer>
        <b-overlay :show="show">
            <div class="row row-container">
                <div class="left-pane">
                    <h4 class="mb-3">{{ sharingForm.company_name }}</h4>
                    <b-form-group label="Vat no:" label-for="" class="b-form-group align-text-setting " label-cols-sm="4" label-size="sm">
                        <b-form-input
                            disabled
                            v-model="$v.sharingForm.vat_no.$model"
                            :state="validateState('vat_no')"
                            aria-describedby="input-1-live-feedback"
                            type="text"
                            class="b-form-input remove-outline disable-text-selection"
                            size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> {{ vatNoErrorMessage }} </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Reg no:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                        <b-form-input
                            disabled
                            v-model="$v.sharingForm.company_reg.$model"
                            :state="validateState('company_reg')"
                            aria-describedby="input-1-live-feedback"
                            type="text"
                            class="b-form-input"
                            size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> {{ regNoErrorMessage }} </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Certificate No:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                        <b-form-input disabled v-model="sharingForm.cert_no" type="text" class="b-form-input" size="sm"></b-form-input>
                    </b-form-group>

                    <b-form-group label="Issue Date:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                        <b-form-input
                            disabled
                            v-model="$v.sharingForm.issue_date.$model"
                            :state="validateState('issue_date')"
                            aria-describedby="input-1-live-feedback"
                            type="date"
                            class="b-form-input"
                            size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Expiry Date:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                        <b-form-input
                            disabled
                            v-model="$v.sharingForm.expiry_date.$model"
                            :state="validateState('expiry_date')"
                            aria-describedby="input-1-live-feedback"
                            type="date"
                            class="b-form-input"
                            size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        v-if="user_role == 'User'"
                        label="Shared By:"
                        label-size="sm"
                        label-cols-sm="4"
                        class="b-form-group align-text-setting"
                    >
                        <b-form-input
                            disabled
                            v-model="$v.sharingForm.share_user.$model"
                            :state="validateState('share_user')"
                            aria-describedby="input-1-live-feedback"
                            type="text"
                            class="b-form-input not-allowed-pointer"
                            size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group v-else label="Shared By:" label-size="sm" label-cols-sm="4" class="b-form-group align-text-setting">
                        <b-form-select
                            @change="onChangeVetting('shared_by')"
                            v-model="$v.sharingForm.share_user_id.$model"
                            :state="validateState('share_user_id')"
                            aria-describedby="input-1-live-feedback"
                            :options="team_member_options"
                            size="sm"
                        ></b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Shared Date:" label-size="sm" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                        <b-form-input
                            disabled
                            v-model="sharingForm.share_date"
                            aria-describedby="input-1-live-feedback"
                            size="sm"
                            type="text"
                            class="b-form-input not-allowed-pointer"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                            {{ vatNoErrorMessage }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <div class="group-of-actions b-form-group">
                        <b-form-group label="Notes:" label-for="textarea-formatter" class="">
                            <b-form-textarea v-model="sharingForm.share_notes" id="textarea-formatter" placeholder="Editable"></b-form-textarea>
                        </b-form-group>
                    </div>

                    <b-alert class="b-form-group text-center" variant="danger" :show="proof_error" dismissible> You must provide proof </b-alert>

                    <div class="group-of-actions d-flex justify-content-center">
                        <!-- <b-button variant="primary" type="button" class="btn btn-primary m-1 mt-2">
                        Upload Proof
                    </b-button> -->
                        <div class="input-file m-1 mt-2">
                            <input @change="onFileSelected" class="btn btn-primary" ref="file" type="file" style="display: none;" />
                            <div class="btn btn-primary" @click="selectFile()">Upload Proof</div>
                        </div>

                        <!-- <div class="group-of-actions d-flex "> -->
                        <b-button @click="newWindow" variant="primary" type="button" class="btn btn-primary m-1 mt-2">
                            <i class="mdi mdi-dock-window mr-1"></i> View
                        </b-button>

                        <b-button @click="share" variant="primary" type="button" class="btn btn-primary m-1 mt-2 float-right">
                            Share
                        </b-button>
                    </div>
                </div>

                <div class="right-pane" v-if="selectedFile">
                    <embed :src="selectedFilePreview" class="w-100 h-100" />
                </div>
                <div v-else class="right-pane d-flex justify-content-center">
                    <div class="text-center font-weight-bold ">Upload proof to preview it</div>
                </div>
            </div>

            <div class="modal-footer mt-3">
                <b-button variant="primary" type="button" class="btn btn-primary" @click="goBack">
                    Back
                </b-button>
                <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                    Close
                </b-button>
            </div>
        </b-overlay>
    </b-modal>
</template>

<script>
//eslint-disable-next-line
import { required, minLength, maxLength, numeric, date } from "vuelidate/lib/validators";
import { adminComputed, suppliersComputed, suppliersMethods } from "../../state/helpers";
import Swal from "sweetalert2";

export default {
    data: () => ({
        proof_error: false,
        show: false,
        selectedFile: "",
        selectedFilePreview: "",
        formSubmit: false,
        sharingForm: {
            certificate_id: "",
            company_name: "",
            vat_no: "",
            company_reg: "",
            cert_no: "",
            issue_date: "",
            expiry_date: "",
            share_proof: "",
            share_notes: "",
            share_user: "",
            share_user_id: "",
            share_date: "",
        },
    }),
    computed: {
        ...suppliersComputed,
        ...adminComputed,
        team_member_options() {
            let teamMemberOptions = [{ value: null, text: "Please select an option", disabled: true }];

            this.teamMembersForCertificates.map((teamMember) => {
                teamMemberOptions.push({ value: teamMember.id, text: `${teamMember.first_name} ${teamMember.last_name}` });
            });

            return teamMemberOptions;
        },
        vatNoErrorMessage() {
            if (!this.$v.sharingForm.vat_no.$dirty) return "";
            if (!this.$v.sharingForm.vat_no.conditionalRequired) {
                return "Either a VAT No or Reg No must be provided.";
            }
            if (this.$v.sharingForm.vat_no.$error) {
                if (this.$v.sharingForm.vat_no.maxLength) {
                    return "VAT No must be 10 digits long.";
                }
                if (this.$v.sharingForm.vat_no.$params.numeric) {
                    return "Can only be numbers.";
                }
                return "A Vat No can only be 10 digits long.";
            }
            return "";
        },
        regNoErrorMessage() {
            if (!this.$v.sharingForm.company_reg.$dirty) return "";
            if (!this.$v.sharingForm.company_reg.conditionalRequired) {
                return "Either a Reg No or Vat no must be provided.";
            }
            if (this.$v.sharingForm.company_reg.$error) {
                if (this.$v.sharingForm.company_reg.$params.minLength) {
                    return "Reg No must be atleast 3 characters long";
                }
                return "Required";
            }
            return "";
        },
    },
    validations: {
        sharingForm: {
            vat_no: {
                conditionalRequired(value) {
                    const isVatNoFilled = !!value;
                    const isCompanyRegFilled = !!this.sharingForm.company_reg;
                    return isVatNoFilled || isCompanyRegFilled;
                },
                minLength: minLength(10),
                maxLength: maxLength(10),
                numeric,
            },
            company_reg: {
                conditionalRequired(value) {
                    const isVatNoFilled = !!this.sharingForm.vat_no;
                    const isCompanyRegFilled = !!value;
                    return isVatNoFilled || isCompanyRegFilled;
                },
                minLength: minLength(3),
            },
            issue_date: {
                required,
            },
            expiry_date: {
                required,
            },
            share_user_id: {
                required,
            },
        },
    },
    methods: {
        ...suppliersMethods,
        onChangeVetting(input) {
            if (input == "shared_by") {
                this.sharingForm.share_date = null;
            }
        },
        selectFile() {
            let fileInputElement = this.$refs.file;
            fileInputElement.click();

            //eslint-disable-next-line
            // console.log("target", e, fileInputElement);
            // ...
        },
        onFileSelected(event) {
            //eslint-disable-next-line

            // this.selectedFile = event.target.files[0];
            this.selectedFile = URL.createObjectURL(event.target.files[0]);
            this.selectedFilePreview = URL.createObjectURL(event.target.files[0]) + "#page=1&zoom=75&toolbar=0";
            //eslint-disable-next-line
            console.log(this.selectedFile, event.target.files[0]);

            // !
            // this.certificate_details.certificate = this.$refs.file.files[0];
            this.sharingForm.share_proof = event.target.files[0];

            this.proof_error = false;
        },
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.sharingForm[name];
                return $dirty ? !$error : null;
            }
        },
        goBack() {
            this.$emit("handleModal", "certificateEditModal");
            this.closeModal();
        },
        // handleDates(date) {
        //     if (date == "issue_date") {
        //         return this.selected_supplier_certificate.issue_date.substring(0, 10);
        //     } else {
        //         return this.selected_supplier_certificate.expiry_date.substring(0, 10);
        //     }
        // },
        closeModal() {
            this.$bvModal.hide("certificateSharingModal");
        },
        localSetCertificateDetails() {
            this.sharingForm.certificate_id = this.selected_supplier_certificate.id;
            this.sharingForm.company_name = this.selected_supplier_certificate.company_name;
            this.sharingForm.vat_no = this.selected_supplier_certificate.vat_no;
            this.sharingForm.company_reg = this.selected_supplier_certificate.company_reg;
            this.sharingForm.cert_no = this.selected_supplier_certificate.certificate_no;
            this.sharingForm.issue_date = this.selected_supplier_certificate.issue_date.substring(0, 10);
            this.sharingForm.expiry_date = this.selected_supplier_certificate.expiry_date.substring(0, 10);
            this.sharingForm.share_notes = this.selected_supplier_certificate.share_notes;

            this.selectedFile = this.selected_supplier_certificate.share_src + "#page=1&zoom=75&toolbar=0";
            this.selectedFilePreview = this.selected_supplier_certificate.share_src + "#page=1&zoom=75&toolbar=0";

            this.sharingForm.share_user = this.username;
            if (this.user_role == "User") {
                this.sharingForm.share_user_id = this.user_id;
            } else {
                this.sharingForm.share_user_id = this.selected_supplier_certificate.share_user_id;
            }

            this.sharingForm.share_date = this.selected_supplier_certificate.share_date;
        },
        share() {
            this.formSubmit = true;

            if (this.sharingForm.share_proof.length < 2) {
                this.proof_error = true;
            }

            this.$v.sharingForm.$touch();
            if (this.$v.sharingForm.$anyError) {
                return;
            }

            if (this.proof_error == true) return;

            this.show = true;
            // this.shareCertificate
            Swal.fire({
                title: `Share Certificate `,
                text: `Are you sure?`,
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    //eslint-disable-next-line
                    console.log("the sharing form", this.sharingForm);
                    this.shareCertificate(this.sharingForm).then(() => {
                        this.formSubmit = false;

                        Swal.fire({ title: ``, text: "Certificate shared", icon: "success" });
                        // this.setCertificateById(this.sharingForm.certificate_id).then(() => {
                        //     // this.$bvModal.hide("certificateSharingModal");
                        //     this.closeModal();
                        //     this.$emit("handleModal", "certificateEditModal");
                        //     // this.closeModal();
                        //     // this.localSetCertificateDetails(); // this will reset the local component state if called here like this
                        // });
                        this.show = false;
                        this.closeModal();
                        this.$emit("handleModal", "certificateEditModal");

                        this.setSearchForCertificatesDetails(null);

                        //eslint-disable-next-line
                        // console.log();
                    });
                } else {
                    this.show = false;
                }
            });
        },
        newWindow() {
            window.open(this.selectedFilePreview, "_blank");
        },
    },
    mounted() {
        this.localSetCertificateDetails();
    },
};
</script>

<style lang="scss" scoped>
//   the default style attached to modal footer  border-top: 1px solid #eff2f7;
.align-text-setting {
    text-align: right;
}
.height {
    min-height: 500px;
}

// this makes the left and right pane in the flex
.row-container {
    display: flex;
    padding: 10px;
}

.left-pane {
    width: 40%;

    .b-form-group {
        margin-right: 50px;
    }
    .b-form-input {
        max-width: 100%;
    }
}
.group-of-actions {
    border-top: 1px solid #eff2f7 !important;
    margin-top: 25px;
    padding-top: 15px;
    margin-right: 25px;
}

.button-width {
    width: 200px;
}

.right-pane {
    // padding: 4px;
    width: 59%;
    display: flex;
    flex-direction: column;
    border: 1px solid black;
}

// the purpose of this media query is simply to make the contents of modal display flex-column
// and then for the panes to have a width off 100% instead of 50%
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
    .row-container {
        flex-direction: column;
    }

    .left-pane {
        width: 100%;
    }

    .right-pane {
        width: 100%;
        margin-top: 25px;
        height: 350px;
    }
}

.disable-text-selection {
    user-select: none;
}
</style>
